import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <SiteHeader />

            <main className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
